/* eslint-disable react/prop-types */
import React from 'react';
import { Avatar,  } from 'antd';

import styles from './MemberList.less';

/**
 * MemberList —— 会员行列表
 * ------------------------------------------------------------------
 * 商家端多处是同一个行结构：头像 + 昵称 + 灰底行为标签 + 右侧会员类型
 * 胶囊与补充文案。目前用在「经营概览 → 下周到期会员」，
 * 「服务交付 → 完课会员列表」同构，第二轮可以换过来复用。
 *
 * @param items   [{ key, avatar, name, badge, stats, tagLabel, tagTone,
 *                   tagImage, extra, detailHref, onClick }]
 *                badge   灰底行为标签，如「完课 3 次，最近 7 天 0 次」
 *                stats   平铺统计项，如 [{ label: '完课', value: '3 次' }]
 *                stats 与 badge 互斥，传入 stats 时优先展示平铺统计项
 *                extra   右侧次要文案，如「2026.09.08」（不拼接到期说明）
 *                detailHref 用户档案详情链接
 * @param emptyText 空态文案
 */
const MemberList = (props) => {
  const { items = [], emptyText = '暂无数据' } = props;

  if (!items.length) {
    return <div className={styles.empty}>{emptyText}</div>;
  }

  return (
    <div className={styles.list}>
      {items.map((m) => (
        <div
          key={m.key || m.name}
          className={`${styles.row} ${m.onClick ? styles.clickable : ''}`}
          onClick={m.onClick}
        >
          <Avatar
            size={44}
            src={m.avatar || undefined}
            className={styles.avatar}
          >
            {(m.name || '?').slice(0, 1)}
          </Avatar>

          <div className={styles.main}>
            <div className={styles.name} title={m.name}>
              {m.name}
            </div>
            {Array.isArray(m.stats) && m.stats.length > 0 ? (
              <div className={styles.stats}>
                {m.stats.map((stat, index) => (
                  <span className={styles.stat} key={`${stat.label}-${index}`}>
                    <span className={styles.statLabel}>{stat.label}</span>
                    {stat.value}
                  </span>
                ))}
              </div>
            ) : (
              m.badge && <span className={styles.badge}>{m.badge}</span>
            )}
          </div>

          <div className={styles.right}>
            {m.tagImage ? (
              <img
                className={styles.tagImage}
                src={m.tagImage}
                alt="会员类型"
              />
            ) : (
              m.tagLabel && (
                <span
                  className={`${styles.tag} ${
                    styles[m.tagTone] || styles.gold
                  }`}
                >
                  {m.tagLabel}
                </span>
              )
            )}
            {m.extra && <span className={styles.extra}>{m.extra}</span>}
            {m.detailHref && (
              <a
                className={styles.detailLink}
                href={m.detailHref}
                target="_blank"
                rel="noreferrer"
                onClick={(event) => event.stopPropagation()}
              >
                查看详情
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MemberList;
